module.exports = __webpack_public_path__ + "static/media/blackEnabledEventIcon.db656c42.svg";